import { Link } from "react-router-dom";
import { useEffect, useState } from "react";
import { collection, orderBy, query, getDocs } from "firebase/firestore";
import { db } from "../firebase";

function Blog() {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchPosts = async () => {
      try {
        const q = query(collection(db, "posts"), orderBy("date", "desc"));
        const snap = await getDocs(q);
        setPosts(snap.docs.map((doc) => ({ id: doc.id, ...doc.data() })));
      } catch (e) {
        setError(e);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  // Log for debugging
  console.log("Blog render, posts:", posts, "error:", error?.message);

  if (loading) {
    return (
      <div className="container mx-auto px-4 py-8">
        <div className="flex justify-center items-center">
          <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-primary" aria-label="Loading" />
        </div>
      </div>
    );
  }

  return (
    <div className="container mx-auto px-4 py-8">
      <h1 className="text-4xl font-bold text-text-light dark:text-text-dark mb-6">
        Blog
      </h1>
      <p className="text-lg text-neutral mb-8">
        Explore our latest articles on habit-building, personal growth, and more.
      </p>
      <div className="space-y-6">
        {error && (
          <p className="text-error text-center">Error loading posts: {error.message}</p>
        )}
        {posts.length === 0 && !error && (
          <p className="text-neutral text-center">No posts available.</p>
        )}
        {posts.map((post) => (
          <div key={post.id} className="card p-6">
            <h2 className="text-2xl font-semibold text-text-light dark:text-text-dark mb-2">
              <Link to={`/blog/${post.id}`} className="hover:text-primary">
                {post.title}
              </Link>
            </h2>
            <p className="text-neutral mb-2">{post.excerpt}</p>
            <p className="text-sm text-neutral">{post.date?.toDate().toISOString().split('T')[0]}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Blog;